import { render, staticRenderFns } from "./FacebookMediaTemplate.vue?vue&type=template&id=7f887e16&"
import script from "./FacebookMediaTemplate.vue?vue&type=script&lang=js&"
export * from "./FacebookMediaTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports